export default "__VITE_ASSET__CK_mf9t0__"